import { createStore , applyMiddleware } from "redux";
import rootReducer from "../reducer";
import thunkMiddleware from "redux-thunk";
import logger from "redux-logger";

const middleware = [thunkMiddleware, logger];
function configureStore(initialState) {
  return createStore(rootReducer, initialState, applyMiddleware(...middleware));
}

const store = configureStore();
export default store;